import { faqBreadcrumb, defBreadcrumb } from "../../../data/DataBreadcrumb";
import Questions from "../../../components/Faq/Questions";
import { pertanyaanUmumMeta } from "../../../data/DataMetatags";
import React from "react";
import TopicWrapperProps from "../../../components/Faq/TopicWrapper";
import axios from "axios";
import { env } from "src/utils/env";

const TopicId = ({
  asPath,
  breadcrumb,
  topicBreadcrumb,
  questions,
  pageTitle,
  description,
  topicId,
  faqTitle,
  faqData,
  header,
}) => {
  return (
    <TopicWrapperProps
      pageTitle={pageTitle}
      asPath={asPath}
      description={description}
      breadcrumb={breadcrumb}
      topicBreadcrumb={topicBreadcrumb}
      questions={questions}
      topicId={topicId}
      header={header}
    >
      <Questions data={faqData} title={faqTitle} topicId={topicId} />
    </TopicWrapperProps>
  );
};

export const getServerSideProps = async (context) => {
  const { query, resolvedUrl } = context;
  const { title, description } = pertanyaanUmumMeta;
  const { topicId, header } = query;

  const topic_id = topicId?.replace(/-/g, "_");

  try {
    const { status: questionsStatus, data: questionsData } = await axios.get(
      `${env.baseUrl}/api/v1/kentico/questions`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${env.auth}`,
        },
      }
    );

    if (questionsStatus !== 200) throw new Error("Failed to fetch questions");

    const { status: topicFaqStatus, data: topicFaqData } = await axios.get(
      `${env.baseUrl}/api/v1/kentico/topic-faq`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${env.auth}`,
        },
        params: {
          topicId: topicId,
        },
      }
    );

    if (topicFaqStatus !== 200) {
      return {
        redirect: {
          destination: `/halaman-tidak-ditemukan?q=pertanyaan-umum/${topic_id}`,
          permanent: false,
        },
      };
    }

    const pageTitle = `${title} - ${topicFaqData.title}`;

    const breadcrumb = [
      ...defBreadcrumb,
      {
        "@type": "ListItem",
        position: "2",
        item: {
          "@id": process.env.baseUrl + "/pertanyaan-umum",
          name: "pertanyaan-umum",
        },
      },
      {
        "@type": "ListItem",
        position: "3",
        item: {
          "@id": process.env.baseUrl + `/pertanyaan-umum/${topicId}`,
          name: pageTitle,
        },
      },
    ];

    const topicBreadcrumb = [
      ...faqBreadcrumb,
      {
        page: topicFaqData.title,
        href: resolvedUrl,
        to: `/pertanyaan-umum/${topicId}`,
      },
    ];

    return {
      props: {
        asPath: resolvedUrl,
        breadcrumb,
        topicBreadcrumb,
        questions: questionsData,
        pageTitle,
        description,
        topicId,
        faqTitle: topicFaqData.title,
        faqData: topicFaqData.data,
        header: header || null,
      },
    };
  } catch (error) {
    return {
      redirect: {
        destination: `/halaman-tidak-ditemukan?q=pertanyaan-umum`,
        permanent: false,
      },
    };
  }
};

export default TopicId;
